module.exports = __webpack_public_path__ + "media/images/countryrect/ao-75b87910bf3b90ce9a08457b65235162.svg";